(function ($) {
  jQuery(document).ready(function () {
    tinyMCE.init({
      mode: "specific_textareas",
      elementpath: false,
      editor_selector: "tinymce-enabled",
      height: 300,
      menu: {},
      statusbar: false,
      plugins: "lists link",
      toolbar: "undo redo | bold italic bullist | link",
      /*plugins : "autolink, lists, spellchecker, style, layer, table, advhr, advimage, advlink, emotions, iespell, inlinepopups, insertdatetime, preview, media, searchreplace, print, contextmenu, paste, directionality, fullscreen, noneditable, visualchars, nonbreaking, xhtmlxtras, template",*/
    });

    var tooltipTriggerList = [].slice.call(
      document.querySelectorAll('[data-bs-toggle="tooltip"]')
    );
    var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
      return new bootstrap.Tooltip(tooltipTriggerEl);
    });

    // -------------------------------------
    // Cookies / modal
    // -------------------------------------

    function setCookie(name, value, hours) {
      var expires = "";

      if (hours) {
        var date = new Date();
        date.setTime(date.getTime() + hours * 60 * 60 * 1000);
        expires = "; expires=" + date.toUTCString();
      }

      document.cookie = name + "=" + (value || "") + expires + "; path=/";
    }

    // alert hláška
    if ($(".modal").length) {
      // zavření modal okna
      $(".js-modal-close, .modal").click(function () {
        $(this).closest(".modal").fadeOut(500);

        setCookie("modal_alert", "alert", 1);
        return false;
      });

      // zamezení zavření po kliknutí na tělo modalu
      $(".modal__body").on("click", function (event) {
        event.stopPropagation();
      });
    }

    // -------------------------------------
    // ScrollTo (click on link)
    // -------------------------------------

    jQuery("a[href^='#']").click(function () {
      var thisHref = jQuery(this).attr("href");
      jQuery.scrollTo(thisHref, 800, {
        axis: "y",
      });
      return false;
    });

    jQuery("li.menu-item-has-children").click(function (event) {
      if (jQuery(this).hasClass("is-hover")) {
        jQuery(this).toggleClass("is-hover");
        jQuery(this).find(".sub-menu").toggleClass("is-show");
      } else {
        jQuery(this).toggleClass("is-hover");
        jQuery(".sub-menu").removeClass("is-show");
        jQuery(this).find(".sub-menu").toggleClass("is-show");
      }
      return false;
    });

    jQuery("li.menu-item-has-children .sub-menu *").click(function (event) {
      event.stopPropagation();
    });

    // -------------------------------------
    // Hamburger menu
    // -------------------------------------

    // Create a new instance of Slidebars
    var controller = new slidebars();

    // Initialize Slidebars
    controller.init();

    jQuery(".js-hamburger").on("click", function (event) {
      event.stopPropagation();
      controller.toggle("slidebar");
    });

    // -------------------------------------
    // Custom select styles
    // -------------------------------------

    jQuery("select.postform").select2();
  });
})(jQuery);
